import { TestIds } from "./test-ids";
import { tidSelector } from "../util/selectors";

const { SANDFIRE_CHECKLIST_LINK, AEDU_ONBOARD_PRE_REQUS_LINK } = TestIds;

export const SELECTORS = {
    AEDU_ONBOARD_PRE_REQUS_LINK: tidSelector(AEDU_ONBOARD_PRE_REQUS_LINK),
    SANDFIRE_CHECKLIST_LINK: tidSelector(SANDFIRE_CHECKLIST_LINK),
};
